import {TaxAuditRecordDetailsResponse} from "src/models/reports/TaxAuditRecordDetails";
import {Box, Container, Header} from "@amzn/awsui-components-react";
import {TPELoadingSpinner} from "src/components/shared/TPELoadingSpinner";
import React from "react";

function ValueWithLabel(props: any) {
    const { label } = props;
    return (
        <div>
            <Box margin={{ bottom: 'xxxs' }} color="text-label">
                {label}
            </Box>
            <div>{props.children}</div>
        </div>
    );
}

export default function TaxAuditRecordInvoiceDetails(props: { taxAuditRecordDetails: TaxAuditRecordDetailsResponse, loading: boolean}) {
    const {taxAuditRecordDetails, loading} = props;

    return <Container
        header={
            <Header variant="h2">Invoice Details</Header>
        }>
        <div className="polaris-content-container-tar-report-details">
            <TPELoadingSpinner loading={loading}>
                {taxAuditRecordDetails != null &&
                    <React.Fragment>
                        <div className="grid-item"><ValueWithLabel label="Invoice Number">{taxAuditRecordDetails.invoiceNumber}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="Invoice Id">{taxAuditRecordDetails.invoiceId}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="Invoice Currency ">{taxAuditRecordDetails.invoiceCurrency}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="Invoice Date">{taxAuditRecordDetails.invoiceDate}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="Invoice Status">{taxAuditRecordDetails.invoiceStatus}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="Invoice Failure Reason">{taxAuditRecordDetails.invoiceFailureReason}</ValueWithLabel></div>
                    </React.Fragment>
                }
            </TPELoadingSpinner>
        </div>
    </Container>
}